import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-[#030303] text-[#8b8d98] font-mono text-xs tracking-widest uppercase"
      >
        <span className="animate-pulse">Authentifiziere…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
